import React from 'react';
import ReactDOM from 'react-dom/client';
import Pages from './pages';

const root = ReactDOM.createRoot(document.getElementById('ai-editor'));
root.render(
  <React.StrictMode>
    <Pages />
  </React.StrictMode>
);
